/**
 * Each shop pack's footstep trail (ADR 0073): sold singly on its pack's page
 * like its other pieces, and added to its bundle by `withPackTrails`
 * (`cosmetics/index.ts`). Every trail sells at the same price.
 */
export const TRAIL_PRICE_CENTS = 399;
export const PACK_TRAILS = [
    {
        pack: 'aurora',
        trail: 'stardust',
        name: 'Traînée d’aurore',
        blurb: 'Des étoiles d’or et de glace s’allument à chacun de tes pas et montent en scintillant.',
    },
    {
        pack: 'dragonslayer',
        trail: 'ashes',
        name: 'Traînée de cendres',
        blurb: 'Des cendres de wyrm s’envolent derrière toi, certaines encore rougeoyantes.',
    },
    {
        pack: 'scarecrow',
        trail: 'straw',
        name: 'Traînée de paille',
        blurb: 'Brins de paille et plumes de corbeau roulent dans ton sillage.',
    },
    {
        pack: 'sylvan',
        trail: 'fireflies',
        name: 'Traînée de lucioles',
        blurb: 'Des lucioles s’éveillent sous tes pas et s’élèvent en clignotant.',
    },
    {
        pack: 'bogwitch',
        trail: 'spores',
        name: 'Traînée de spores',
        blurb: 'Des spores luminescentes montent de chaque empreinte, comme au fond des tourbières.',
    },
    {
        pack: 'djinn',
        trail: 'sand',
        name: 'Traînée de sable',
        blurb: 'De petits tourbillons de sable dansent derrière toi, comme un mirage.',
    },
    {
        pack: 'shaman',
        trail: 'snow',
        name: 'Traînée de neige',
        blurb: 'Des flocons tourbillonnent autour de toi et se posent sur ton chemin.',
    },
];
export const PACK_TRAIL_FILE = {
    templates: PACK_TRAILS.map((entry) => ({
        id: `trail-${entry.trail}`,
        lootable: false,
        cosmetic: true,
        name: entry.name,
        kind: 'equipment',
        slot: 'trail',
        rarity: 'epic',
        trail: entry.trail,
        icon: `icon.trail-${entry.trail}`,
    })),
    offers: PACK_TRAILS.map((entry) => ({
        id: `trail-${entry.trail}`,
        name: entry.name,
        blurb: entry.blurb,
        pack: entry.pack,
        items: [{ templateId: `trail-${entry.trail}` }],
        priceCents: TRAIL_PRICE_CENTS,
    })),
};
/** A bundle (an offer of its pack listing several items) with its pack's trail added; any other offer as it is. Its worth follows (`worthOf`, `shop.ts`). */
export function withPackTrail(raw) {
    if (typeof raw !== 'object' || raw === null)
        return raw;
    const offer = raw;
    const entry = PACK_TRAILS.find((candidate) => candidate.pack === offer.pack);
    if (entry === undefined || !Array.isArray(offer.items) || offer.items.length < 2)
        return raw;
    return {
        ...offer,
        items: [...offer.items, { templateId: `trail-${entry.trail}` }],
    };
}
//# sourceMappingURL=pack-trails.js.map